// src/theme.js
import colors from 'vuetify/es5/util/colors'


export default {
  primary: '#166A8F',
  complement: "#1811a9",
  secondary: '#F98B12',
  tertiary: '#438FAD',
  accent: '#CD0904',
  error: '#f55a4e',
  info: '#00d3ee',
  success: '#5cb860',
  warning: '#ffa21a'
}
